import { SVGProps } from 'react';

const AudioLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 10v3m4-7v11m4-14v18m4-13v7m4-10v13m4-8v3"
    />
  </svg>
);
export default AudioLines;
